<template>
  <div class="content-testimonial">
    <div class="inner">
      <div class="content">
        <h2 v-if="data.title" class="title text-xl" v-html="data.title" />
        <StructuredText v-if="data.statement" :data="data.statement" class="structured-text quote" />
        <p v-if="data.name" class="name copy-small-bold">
          {{ data.name }}
        </p>
        <p v-if="data.role" class="role copy-small-bold">{{ data.role }}</p>
      </div>
      <div class="imagewrapper">
        <Image
          v-if="data.image && data.image.responsiveImage"
          class="image"
          :data="data.image.responsiveImage"
          object-fit="cover"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Image, StructuredText } from 'vue-datocms';
import type { ContentTestimonialFragment } from '#gql';

defineProps<{
  data: ContentTestimonialFragment;
}>();
</script>

<style scoped lang="scss">
.content-testimonial {
  @include grid-layout();

  & {
    width: 100%;
    max-width: var(--site-max-width);
    padding: var(--site-inner-padding);

    @media (--xs), (--sm) {
      margin: var(--spacing-md) 0;
    }

    @media (--md), (--lg) {
      margin: var(--spacing-3xl) 0;
    }
  }

  > .inner {
    grid-column: 1 / -1;

    @media (--sm) {
      grid-column: 2 / 24;
    }

    @media (--xs), (--sm) {
      display: flex;
      flex-direction: column;
    }

    @media (--md), (--lg) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }

    > .content,
    > .imagewrapper {
      @media (--md), (--lg) {
        padding: var(--spacing-2xl) var(--spacing-lg);
      }

      @media (--lg-custom) {
        padding: var(--spacing-lg) 8.5rem;
      }
    }

    > .content {
      background-color: var(--color-turquoise-light);
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: var(--spacing-3xs);

      @media (--xs) {
        padding: var(--spacing-md) var(--spacing-xs);
      }

      @media (--sm) {
        padding: var(--spacing-md) var(--spacing-xs);
      }

      > .title {
        color: var(--base-color-foreground);
      }

      > .name {
        margin-bottom: calc(var(--spacing-3xs) * -1);
      }
    }

    > .imagewrapper {
      background-color: var(--color-babyblue);
      width: 100%;
      height: 100%;
      display: grid;
      place-items: center;

      @media (--xs), (--sm) {
        order: -1;
      }

      @media (--xs) {
        padding: var(--spacing-lg) var(--spacing-xs);
      }

      @media (--sm) {
        padding: var(--spacing-lg) 25%;
      }

      > .image {
        aspect-ratio: 1 / 1;
        border-radius: 50%;
      }
    }
  }
}
</style>
